// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"4722103e","845":"571876a1"}[chunkId] + ".chunk.js";
};